import {jsx as _jsx} from "react/jsx-runtime"; function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import graphql from 'babel-plugin-relay/macro'
import {useFragment} from 'react-relay'


import useAtmosphere from '../../hooks/useAtmosphere'
import {useTipTapTaskEditor} from '../../hooks/useTipTapTaskEditor'
import OutcomeCardContainer from '../../modules/outcomeCard/containers/OutcomeCard/OutcomeCardContainer'
import isTaskArchived from '../../utils/isTaskArchived'
import isTempId from '../../utils/relay/isTempId'
import NullCard from '../NullCard/NullCard'











const NullableTask = (props) => {
  const {
    area,
    className,
    isAgenda,
    task: taskRef,
    isDraggingOver,
    isViewerMeetingSection,
    meetingId
  } = props
  const task = useFragment(
    graphql`
      # from this place upward the tree, the task components are also used outside of meetings, thus we default to null here
      fragment NullableTask_task on Task
      @argumentDefinitions(meetingId: {type: "ID", defaultValue: null}) {
        id
        content
        createdBy
        createdByUser {
          preferredName
        }
        integration {
          __typename
        }
        status
        teamId
        tags
        ...OutcomeCardContainer_task @arguments(meetingId: $meetingId)
      }
    `,
    taskRef
  )
  const {content, createdBy, createdByUser, integration, teamId, id: taskId, tags} = task
  const isIntegration = !!_optionalChain([integration, 'optionalAccess', _ => _.__typename])
  const {preferredName} = createdByUser
  const atmosphere = useAtmosphere()
  const isArchived = isTaskArchived(tags)
  const readOnly = isTempId(taskId) || isArchived || !!isDraggingOver || isIntegration
  const {editor} = useTipTapTaskEditor(content, {
    atmosphere,
    teamId,
    readOnly
  })

  const showOutcome =
    editor && (!editor.isEmpty || createdBy === atmosphere.viewerId || isIntegration)
  return showOutcome ? (
    _jsx(OutcomeCardContainer, {
      area: area,
      className: className,
      editor: editor,
      isDraggingOver: isDraggingOver,
      isAgenda: isAgenda,
      task: task,
      isViewerMeetingSection: isViewerMeetingSection,
      meetingId: meetingId,}
    )
  ) : (
    _jsx(NullCard, { className: className, preferredName: preferredName,} )
  )
}

export default NullableTask
